import Button from "Components/Common/Button/Button";

interface GcStepBarProps {
  steps: string[];
  currentStep: number;
  onGoStep: (stepNumber: number) => void;
}

const GcStepBar = ({ steps, currentStep, onGoStep }: GcStepBarProps) => {
  return (
    <div className="stepsBar">
      {steps.map((step, index) => {
        const stepNumber = index + 1;
        const isDone = stepNumber < currentStep;
        const isActive = stepNumber === currentStep;

        return (
          <div className="stepWrap" key={step}>
            <Button
              type="button"
              className={`step ${isDone ? "done" : ""} ${isActive ? "active" : ""}`.trim()}
              onClick={() => onGoStep(stepNumber)}
            >
              <span className="stepNum">{isDone ? "✓" : stepNumber}</span>
              {step}
            </Button>
            {stepNumber < steps.length ? (
              <span className="stepSep">&gt;</span>
            ) : null}
          </div>
        );
      })}
    </div>
  );
};

export default GcStepBar;
